<template>
  <div class="search-region">
    <tk-flex wrap :gutter="15">
      <div
        v-for="(item,index) in areaList" :key="index"
        @click="search(index,item)"
        :class="[selIndex === index ? 'sel':'unsel']"
      >
        {{item.name}}（{{item.count}}）
      </div>
    </tk-flex>
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      require: true
    },
    filters: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  watch: {
    filters () {
      this.getInit()
    }
  },
  data () {
    return {
      areaList: [
        {
          name: '全部',
          type: 'all',
          count: 0
        },
        {
          name: '新华区',
          type: '130105',
          mode: 'carpooling',
          count: 0
        },
        {
          name: '长安区',
          type: '130102',
          mode: 'carpooling',
          count: 0
        },
        {
          name: '桥西区',
          type: '130104',
          mode: 'carpooling',
          count: 0
        },
        {
          name: '裕华区',
          type: '130108',
          mode: 'carpooling',
          count: 0
        },
        {
          name: '高新区',
          type: '130171',
          mode: 'carpooling',
          count: 0
        },
        {
          name: '其他',
          type: 'other',
          mode: 'carpooling',
          count: 0
        },
        {
          name: '包车',
          type: 'charter',
          mode: 'charter',
          count: 0
        }
      ],
      selIndex: 0
    }
  },
  mounted () {
    this.getInit()
  },
  methods: {
    async getInit () {
      try {
        let filter = this.$tkHelper.deepClone(this.filters)
        delete filter.area
        delete filter.mode
        let { data: res } = await this.$tkParse.get(`/aggregate/trip`, {
          params: {
            group: {
              objectId: '$area',
              total: {
                $sum: 1
              }
            },
            match: {
              status: this.status,
              mode: 'carpooling',
              ...filter
            }
          }
        })
        let { data: total } = await this.$tkParse.get(`/aggregate/trip`, {
          params: {
            group: {
              objectId: '',
              total: {
                $sum: 1
              }
            },
            match: {
              status: this.status,
              ...filter
            }
          }
        })
        this.areaList.forEach(e => {
          e.count = 0
        })
        if (total.results.length) {
          this.areaList[0].count = total.results[0].total
        }
        let count = 0
        res.results.forEach(item => {
          count += item.total
          let index = this.areaList.findIndex(e => e.type === item.objectId)
          if (index > -1) {
            this.areaList[index].count += item.total
          }
        })
        this.areaList[this.areaList.length - 1].count += this.areaList[0].count - count
      } catch (e) {
        console.log(e)
      }
    },
    search (index, item) {
      this.selIndex = index
      this.$emit('searchRegion', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.search-region{
  background: #ffffff;
  padding: 24px 24px 0 24px;
  .sel{
    width: 122px;
    text-align: center;
    padding: 6px 0;
    background-color: #00C199;
    border: 1px solid #00C199;
    border-radius: 2px;
    color: white;
    cursor: pointer;
  }
  .unsel{
    width: 122px;
    text-align: center;
    padding: 6px 0;
    border: 1px solid #00C199;
    border-radius: 2px;
    color: #00C199;
    cursor: pointer;
  }
}
</style>
